import { _ } from "libs";
import React, { useEffect, useState } from "react";
import withRedux from "../../withRedux";
import { RootState } from "../../reducers";
import { Profile, Connected, NewsletterSettings } from "../../types";
import { updateProfile, loadNewsletterSettings, flash } from "../../actions";
import NotificationsForm from "../../components/settings/notificationsForm";
import Loader from "../../components/loader";
import reactToString from "../../libs/reactToString";

type Props = {
	profile: Profile;
	updateProfile: Connected<typeof updateProfile>;
};

const Notifications = ({ profile, updateProfile }: Props) => {
	const [newsletterSettings, setNewsletterSettings] = useState({
		subscribed: false,
		url: null,
	} as NewsletterSettings);

	useEffect(() => {
		loadNewsletterSettings().then(settings => {
			setNewsletterSettings(settings);
		});
	}, []);

	const onNotificationSettingsChange = (notificationSettings: Profile["notificationSettings"]) => {
		updateProfile({ notificationSettings });
		flash(_("form.message.saved"));
	};

	return (
		<>
			<h5>{_("notifications.heading")}</h5>
			<div className="notificationSettings">
				<div className="row head">
					<div className="name" />
					<div className="email">
						<div className="icon" title={_("notificationsForm.email.title")} />
						<p>{_("notificationsForm.email.title")}</p>
					</div>
					<div className="push">
						<div className="icon" title={_("notificationsForm.push.title")} />
						<p>{_("notificationsForm.push.title")}*</p>
					</div>
				</div>
				<NotificationsForm profile={profile} onChange={onNotificationSettingsChange} />
				<div
					className="note"
					dangerouslySetInnerHTML={{
						__html: _("notificationsForm.pushNotificationsNote", null, {
							iOSLink: reactToString(
								<a
									href="http://got.link/ios"
									className="link plain"
									target="_blank"
									rel="noopener noreferrer"
								>
									iOS
								</a>
							),
							androidLink: reactToString(
								<a
									href="http://got.link/android"
									className="link plain"
									target="_blank"
									rel="noopener noreferrer"
								>
									Android
								</a>
							),
						}),
					}}
				/>
			</div>
			<h5>{_("newsletter.heading")}</h5>
			<div className="newsletterSettings">
				{newsletterSettings.url === null ? (
					<Loader />
				) : (
					<>
						<p>
							{newsletterSettings.subscribed
								? _("newsletter.status.subscribed")
								: _("newsletter.status.notSubscribed")}
						</p>
						<p>
							<a
								href={newsletterSettings.url}
								className="link blue"
								target="_blank"
								rel="noopener noreferrer"
							>
								{_("newsletter.manageBtn")}
							</a>
						</p>
					</>
				)}
			</div>
		</>
	);
};

export default withRedux({ updateProfile }, ({ profile }: RootState) => {
	return { profile };
})(Notifications);
